import React, { Component } from "react";
import { useSelector } from "react-redux";

// const selectedStyle = {
//   cursor: "pointer",
//   backgroundColor: "#9df3b1 !important",
//   border: "4px solid #098434 !important",
//   borderRadius: "10px !important",
// };

const DifficultLevel = (props: any) => {
  const user = useSelector((storeState: any) => storeState.user);
  console.log(props.difficult_id, "her");
  return (
    <div className="col-12 row m-0 p-0 align-items-center align-items-center ">
      {!user?.isExternalUser && (
        <>
          <div className="col-sm-6">
            <label className=" text-white ml-1">Difficult level: </label>
            <select
              className="form-control "
              name="difficult"
              id="difficult"
              defaultValue={props.difficult_id}
              onChange={(e: any) => props.onChangeDifficult(e.target.value)}
            >
              <option value="">Select</option>
              <option value="1">Basic Level</option>
              <option value="2">Intermediate Level</option>
              <option value="3">Advanced Level</option>
            </select>
          </div>

          <div className="col-sm-6">
            <label className="text-white">Cognitive level: </label>

            <select
              className="form-control "
              name="cognitive"
              id="cognitive"
              defaultValue={props.cognitive_id}
              onChange={(e: any) => props.onChangeCognitive(e.target.value)}
            >
              <option value="">Select</option>
              <option value="1">Remember</option>
              <option value="2">Understand</option>
              <option value="3">Apply</option>
              <option value="4">Analyze</option>
              <option value="5">Evaluate</option>
              <option value="6">Create</option>
            </select>
          </div>
        </>
      )}
    </div>
  );
};

export default DifficultLevel;
